import script from "./BodyTypesView.vue?vue&type=script&setup=true&lang=js"
export * from "./BodyTypesView.vue?vue&type=script&setup=true&lang=js"

import "./BodyTypesView.vue?vue&type=style&index=0&id=ee02b132&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee02b132"]])

export default __exports__